import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import MultiSelectListComponent from 'components/MultiSelectList/MultiSelectList';
import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const OpportunityOverlayWrapper = styled(motion.div)`
  margin: 132px 16px 16px 16px;
  color: ${colors.black};

  ${mediaDesktop(css`
    margin: 144px 122px 124px 122px;
  `)}
`;

export const Filters = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  ${mediaDesktop(css`
    grid-template-columns: 1fr 1fr;
    flex-direction: row;
    grid-column-gap: 32px;

    padding: 28px 0 0 0;
    border-top: 1px solid #e3e3e3;
    border-bottom: 1px solid #e3e3e3;
  `)}
`;

export const FiltersLabel = styled.span`
  ${({ theme: { locale } }) => setTypography('button', locale)}
  display: none;
  grid-column: 1/-1;

  ${mediaDesktop(css`
    display: block;
    margin-bottom: 27px;
  `)}
`;

export const Title = styled.div`
  ${({ theme: { locale } }) => setTypography('heading2', locale)}
  padding-bottom: 48px;

  ${mediaDesktop(css`
    padding-bottom: 64px;
  `)}
`;

export const MultiSelectList = styled(MultiSelectListComponent)``;

export const Label = styled.span`
  ${({ theme: { locale } }) => setTypography('small', locale)}
  display: inline-block;
`;

export const FilterWrapper = styled.div`
  width: 100%;
  grid-column: 1/-1;
  ${({ theme: { locale } }) => setTypography('small', locale)}

  display: flex;
  flex-direction: column;
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0px;
  }

  ${mediaDesktop(css`
    grid-column: auto;
    margin-bottom: 40px;
  `)}

  ${Label} {
    margin-bottom: 6px;
  }
`;

export const Counter = styled.span`
  ${({ theme: { locale } }) => setTypography('small', locale)}
  display: inline-block;
  margin-bottom: 12px;
  margin-top: 56px;

  ${mediaDesktop(css`
    margin-bottom: 14px;
  `)}
`;

export const AppliedFiltersWrapper = styled.div`
  grid-column: 1/-1;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 32px;

  ${Label} {
    margin-bottom: 11px;
  }

  ${mediaDesktop(
    css`
      margin-top: 0;
      padding-bottom: 29px;
      border-bottom: none;
    `
  )}
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  overflow-x: auto;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0px;
  }

  &::-webkit-scrollbar {
    display: none;
  }
  /* flex-wrap: wrap; */
`;

export const Icon = styled.img`
  position: absolute;
  top: 32px;
  right: 32px;
`;

export const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.concrete};
  padding: 10px 16px;
  border-radius: 33px;
  text-align: center;
  white-space: nowrap;
  margin-right: 8px;
  cursor: pointer;
  ${({ theme: { locale } }) => setTypography('filter', locale)}

  svg {
    margin-left: 10px;
    width: 8px;
    height: 8px;
  }
`;

export const Opportunities = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Opportunity = styled(motion.div)`
  position: relative;
  display: flex;
  flex-direction: column;

  background-color: ${colors.concrete};
  padding: 20px;
  cursor: pointer;

  margin-bottom: 12px;

  svg {
    transition: transform 0.3s;
    display: none;
    position: absolute;
    top: 32px;
    right: 32px;
    opacity: 0.3;

    path {
      fill: ${colors.lighterMineShaft};
    }
  }

  ${mediaDesktop(css`
    padding: 24px;
    svg {
      display: block;
    }
  `)}

  &:hover {
    background-color: ${colors.mercury};
    svg {
      transform: translate(8px, -8px);
      opacity: 1;
    }
  }
`;

export const OpportunityTitle = styled.span`
  ${({ theme: { locale } }) => setTypography('heading5', locale)}
  margin-bottom: 24px;

  ${mediaDesktop(css`
    margin-bottom: 64px;
  `)}
`;

export const Text = styled.span`
  ${({ theme: { locale } }) => setTypography('smallBody', locale)}
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0px;
  }

  ${mediaDesktop(css`
    display: inline-block;
    width: 196px;
    margin-right: 32px;

    &:last-child {
      margin-right: 0;
    }
  `)}
`;

export const Break = styled.div`
  height: 24px;
`;

export const JobDataWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaDesktop(css`
    flex-direction: row;
  `)}
`;
